import httpService from './http.service';
import axios from 'axios';

const http = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_STAGING_API}`,
});

export const getDpInfo = async (idDP) => {
  const response = await http.get(`/dinner/${idDP}/details/`);
  return response.data.data;
};
export const getDpInfoWithToken = async (idDP) => {
  const response = await httpService.get(`/dinner/${idDP}/details/`);
  return response.data.data;
};
export const searchDinnerParties = ( textRequest, churchID,) => {
  const response = http.get(
    `/dinner/v1/find-party/${churchID}/unauthenticated/?longitude=${
      textRequest.longitude
    }&latitude=${textRequest.latitude}&title=${textRequest.title}${
      textRequest.type > 0 ? `&type=${textRequest.type}` : ''
    }`
  );
  return response;
};

export const requestJoinDp = (data) =>
  httpService.post(`/member/send_onboard_form/`, data);

export const getMyGroups = (isLeader, page) =>
  httpService.get(
    `/dinner/get-my-groups/?is_leader=${isLeader}&cursor=${page}`
  );

export const GetHighlights = (idDP) =>
  httpService.get(`/dinner/${idDP}/highlights/list/`);
